export default __webpack_public_path__ + "assets/images/e2bf0084306bd9fc53f93000235d8fa3.png";